<template>
	<div>
		<el-tabs type="border-card" class="maintab" style="overflow: auto">
			<el-tab-pane>
				<span slot="label"><i class="el-icon-files"></i> 基本数据统计</span>
				<el-button
					type="primary"
					size="mini"
					style="margin-bottom: 5px"
					@click="
						exportPlainStatistic('PlainStaticTable', '工程档案项目基本数据')
					"
					><i class="el-icon-download"></i>&nbsp; 导出数据</el-button
				>
				<el-table
					:data="plainStaticList"
					ref="PlainStaticTable"
					id="PlainStaticTable"
					v-loading="plainStaticLoading"
					height="610"
					size="mini"
					border
					style="width: 100%"
					element-loading-text="拼命加载中"
					element-loading-spinner="el-icon-loading"
					element-loading-background="rgba(255, 255, 255, 0.8)">
					<el-table-column
						label="年份"
						width="100"
						prop="yearStr"></el-table-column>
					<el-table-column
						label="项目总数"
						width="120"
						prop="projectSumNum"></el-table-column>
					<el-table-column
						label="已签约数"
						width="120"
						prop="signedNum"></el-table-column>
					<el-table-column
						label="已完成数"
						width="120"
						prop="completedNum"></el-table-column>
					<el-table-column
						label="已废弃数"
						width="120"
						prop="wastedNum"></el-table-column>
					<el-table-column
						label="未付款数"
						width="120"
						prop="unMoneyedNum"></el-table-column>
					<el-table-column
						label="已付款数"
						width="120"
						prop="moneyedNum"></el-table-column>
					<el-table-column
						label="已付全款数"
						width="120"
						prop="moneyedAllNum"></el-table-column>
					<el-table-column
						label="客户数"
						width="120"
						prop="customerNum"></el-table-column>
				</el-table>
			</el-tab-pane>
			<el-tab-pane>
				<span slot="label"><i class="el-icon-s-order"></i> 合同金额前三十</span>
				<el-button
					type="primary"
					size="mini"
					style="margin-bottom: 5px"
					@click="
						exportPlainStatistic(
							'Top30ProTable',
							'工程档案项目合同金额前30数据'
						)
					"
					><i class="el-icon-download"></i>&nbsp; 导出数据</el-button
				>
				<el-table
					:data="top30ProList"
					ref="top30ProTable"
					id="Top30ProTable"
					v-loading="Top30ProLoading"
					height="610"
					size="mini"
					border
					style="width: 100%"
					element-loading-text="拼命加载中"
					element-loading-spinner="el-icon-loading"
					element-loading-background="rgba(255, 255, 255, 0.8)">
					<el-table-column type="index" width="50"> </el-table-column>
					<el-table-column
						label="项目编号"
						prop="panum"
						width="160"
						show-overflow-tooltip></el-table-column>
					<el-table-column
						label="项目名称"
						prop="paname"
						width="330"
						show-overflow-tooltip></el-table-column>
					<el-table-column
						label="建设单位"
						prop="paunit"
						width="300"
						show-overflow-tooltip></el-table-column>
					<el-table-column
						label="合同金额"
						sortable
						:sort-method="
							(a, b) => {
								return a - b
							}
						"
						prop="pamoney"
						width="100"
						show-overflow-tooltip></el-table-column>
					<el-table-column
						label="拍摄进度"
						prop="photoproname"
						width="100"
						show-overflow-tooltip></el-table-column>
					<el-table-column
						label="实施进度"
						prop="receproname"
						width="100"
						show-overflow-tooltip></el-table-column>
					<el-table-column label="操作" width="140">
						<template slot-scope="scope">
							<el-button
								type="primary"
								plain
								size="mini"
								@click="openDetail(scope.row.panum)"
								>详情</el-button
							>
						</template>
					</el-table-column>
				</el-table>
			</el-tab-pane>
			<el-tab-pane>
				<span slot="label"
					><i class="iconfont icon-shenhe1"></i> 项目登记情况统计</span
				>
				<register-statistic></register-statistic>
			</el-tab-pane>
			<el-tab-pane>
				<span slot="label"
					><i class="iconfont icon-jiancharenwuguanli"></i>
					项目完成情况统计</span
				>
				<complete-statistic></complete-statistic>
			</el-tab-pane>
			<el-tab-pane>
				<span slot="label"
					><i class="iconfont icon-genzongdingwei"></i> 项目跟进记录统计</span
				>
				<trace-history></trace-history>
			</el-tab-pane>
		</el-tabs>

		<!--正式项目详情-->
		<project-detail
			ref="Detail"
			:detailFormCp="detailForm"
			:modifyDisable="true"
			:flushDetail="openDetail"
			:paclassList="paclassList"
			:pacontentList="pacontentList"
			:jzxzList="jzxzList"
			:danweiList="danweiList"
			:photoproList="photoproList"
			:receproList="receproList"
			:papsdutyList="papsdutyList"
			:detailVisible="detailVisible"
			@changeVisible="changeDetailVisible"></project-detail>
	</div>
</template>
<script>
import dayjs from "dayjs"
import FileSaver from "file-saver"
import XLSX from "xlsx"
//引入项目详情
import ProjectDetail from "../../components/official/ProjectDetail.vue"
import RegisterStatistic from "../../components/official/RegisterStatistic.vue"
import CompleteStatistic from "../../components/official/CompleteStatistic.vue"
import TraceHistory from "../../components/official/TraceHistory.vue"
export default {
	name: "proStatistic",
	components: {
		ProjectDetail,
		RegisterStatistic,
		CompleteStatistic,
		TraceHistory,
	},
	data() {
		return {
			//项目数据统计
			plainStaticList: [],
			plainStaticLoading: false,
			//金额前30排名
			top30ProList: [],
			Top30ProLoading: false,
			detailForm: {
				projecta: {},
				historyOne: null,
				historyTwo: null,
				historyThree: null,
				htpicDetailList: [],
				contentList: [],
				jzxzList: [],
			},
			detailVisible: false, //详情面板是否可见
			paclassList: [],
			pacontentList: [],
			jzxzList: [],
			danweiList: [],
			receproList: [],
			photoproList: [],
			papsdutyList: [],
		}
	},
	mounted() {
		this.getDetailParams()
		this.getPlainStaticList()
		this.getTop30ProData()
	},
	methods: {
		//获取基本统计数据
		async getPlainStaticList() {
			this.plainStaticLoading = true
			const { data: res } = await this.$http.post("os/plain").catch(err => err)
			if (res) {
				this.plainStaticList = res
			}
			this.plainStaticLoading = false
		},
		//导出基本数据统计
		exportPlainStatistic(id, name) {
			if (this.plainStaticList.length > 0) {
				this.plainStaticLoading = true
				this.Top30ProLoading = true
				this.$notify.info({
					title: "消息",
					message: "正在导出基本数据统计...",
					duration: 2000,
				})
				var xlsxParam = { raw: true } //转换成excel时，使用原始的格式
				var wb = XLSX.utils.table_to_book(
					document.querySelector("#" + id),
					xlsxParam
				) //outTable为列表id
				var wbout = XLSX.write(wb, {
					bookType: "xlsx",
					bookSST: true,
					type: "array",
				})
				try {
					var dateNow = new Date()
					FileSaver.saveAs(
						new Blob([wbout], {
							type: "application/octet-stream;charset=utf-8",
						}),
						name +
							"统计导出_" +
							dayjs(dateNow).format("YYYYMMDD_HHmmss") +
							".xlsx"
					)
				} catch (e) {
					if (typeof console !== "undefined") console.log(e, wbout)
				}
				this.plainStaticLoading = false
				this.Top30ProLoading = false
				//导出完成
				this.$notify({
					title: "成功",
					message: "数据已成功导出！",
					type: "success",
					duration: 2000,
				})
				return wbout
			} else {
				this.$message.warning("没有可供导出的数据！")
			}
		},
		//获取金额前30数据
		async getTop30ProData() {
			this.Top30ProLoading = true
			const { data: res } = await this.$http.post("os/top30").catch(err => err)
			if (res) {
				this.top30ProList = res
			}
			this.Top30ProLoading = false
		},
		//查看详情
		async openDetail(panum) {
			const { data: res } = await this.$http.post("official/detail", {
				data: panum,
			}).catch(err => err)
			if (res) {
				this.detailForm = res
				this.detailVisible = true
			}
		},
		changeDetailVisible(val) {
			this.detailVisible = val
		},
		// #region 详情参数
		//获取项目类别列表
		async getAclassList() {
			const { data: res } = await this.$http.post("atimport/aclassList").catch(err => err)
			if (res) {
				this.paclassList = res
			}
		},
		//获取项目内容列表
		async getPacontentList() {
			const { data: res } = await this.$http.post("/item/content").catch(err => err)
			if (res) {
				this.pacontentList = res
			}
		},
		//获取工程类型列表
		async getjzxzList() {
			const { data: res } = await this.$http.post("/item/status").catch(err => err)
			if (res) {
				this.jzxzList = res
			}
		},
		//获取单位列表
		async getdanweiList() {
			const { data: res } = await this.$http.post("/item/danwei").catch(err => err)
			if (res) {
				this.danweiList = res
			}
		},
		//获取整理接收进度
		async getRecepeoList() {
			const { data: res } = await this.$http.post("item/recepros").catch(err => err)
			if (res) {
				this.receproList = res
			}
		},
		//获取声像拍摄进度
		async getPhotoproList() {
			const { data: res } = await this.$http.post("item/photopros").catch(err => err)
			if (res) {
				this.photoproList = res
			}
		},
		//获取拍摄责任人
		async getPsmemberList() {
			const { data: res } = await this.$http.post("item/psmembers").catch(err => err)
			if (res) {
				this.papsdutyList = res
			}
		},
		getDetailParams() {
			this.getAclassList()
			this.getPacontentList()
			this.getjzxzList()
			this.getdanweiList()
			this.getRecepeoList()
			this.getPhotoproList()
			this.getPsmemberList()
		},
		// #endregion
	},
}
</script>
<style scope></style>
